import FacebookIcon from './icons/facebook.svg';
import GithubIcon from './icons/github.svg';
import LinkedInIcon from './icons/linkedin.svg';
import SlackIcon from './icons/slack.svg';
import TwitterIcon from './icons/twitter.svg';
import YoutubeIcon from './icons/youtube.svg';

export const navItems = [
  {
    title: 'Community',
    items: [
      {
        title: 'TiKV',
        link: 'https://tikv.org',
      },
      {
        title: 'Chaos Mesh®',
        link: 'https://chaos-mesh.org',
      },
      {
        title: 'Slack',
        link: 'https://slack.tidb.io/invite?team=tidb-community&channel=everyone',
      },
      {
        title: 'Forum',
        link: 'https://pingkai.cn/tidbcommunity/forum',
      },
      {
        title: 'Mailing List',
        link: 'https://lists.tidb.io/g/main/subgroups',
      },
    ],
  },
  {
    title: 'Resources',
    items: [
      {
        title: 'Quick Start',
        link: 'https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb',
      },
      {
        title: 'Best Practices',
        link: 'https://docs.pingcap.com/zh/tidb/stable/tidb-best-practices',
      },
      {
        title: 'FAQs',
        link: 'https://docs.pingcap.com/zh/tidb/stable/tidb-faq',
      },
      {
        title: 'Release Notes',
        link: 'https://docs.pingcap.com/zh/tidb/dev/release-notes',
      },
      {
        title: 'Blog',
        link: 'https://pingcap.com/blog',
      },
      {
        title: 'Github',
        link: 'https://github.com/pingcap/tidb',
      },
    ],
  },
  {
    title: 'Learning',
    items: [
      {
        title: 'Docs',
        link: 'https://docs.pingcap.com/tidb/stable',
      },
      {
        title: 'Case Studies',
        link: 'https://pingcap.com/case-studies',
      },
      {
        title: '平凯星辰 Education',
        link: 'https://university.pingcap.com',
      },
      {
        title: 'TiDB in Action',
        link: 'https://book.tidb.io',
      },
    ],
  },
];

export const icons = [
  {
    icon: GithubIcon,
    link: 'https://github.com/pingcap',
  },
  {
    icon: TwitterIcon,
    link: 'https://twitter.com/PingCAP',
  },
  {
    icon: FacebookIcon,
    link: 'https://facebook.com/pingcap2015',
  },
  {
    icon: LinkedInIcon,
    link: 'https://linkedin.com/company/pingcap',
  },
  {
    icon: SlackIcon,
    link: 'https://slack.tidb.io/invite?team=tidb-community&channel=everyone&ref=pingcap',
  },
  {
    icon: YoutubeIcon,
    link: 'https://youtube.com/channel/UCuq4puT32DzHKT5rU1IZpIA',
  },
];
